export default "__VITE_ASSET__DEezEMix__"